import { useState } from 'react';
import type { Reward } from '../../shared/types';
import { formatAmount } from '../lib/format';
import { iconFor } from '../lib/items';

/**
 * A reward as a pill. The icon is best-effort: an item we have no art for, or
 * art that fails to load, falls back to the plain text pill rather than
 * leaving a broken image in the card.
 */
export function RewardPill({ reward }: { reward: Reward }) {
  const [iconFailed, setIconFailed] = useState(false);
  const icon = iconFor(reward.item);
  const showIcon = icon !== null && !iconFailed;

  return (
    <span className={`reward${showIcon ? '' : ' is-plain'}`}>
      {showIcon && (
        <img src={icon} alt="" width={20} height={20} onError={() => setIconFailed(true)} />
      )}
      {reward.amount !== null && <b>{formatAmount(reward.amount)}</b>}
      {reward.item}
    </span>
  );
}
